import type { PerguntaItem } from "../models/perguntaPesquisaSatisfacaoModel"

export enum PerguntaPesquisaSatisfacaoActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR = "ADICIONAR",
    REMOVER = "REMOVER",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    CONFIRMAR_SAVE = "CONFIRMAR_SAVE",
}

export type PerguntaPesquisaSatisfacaoActionModel =
    | {
          type: PerguntaPesquisaSatisfacaoActionsTypes.CARREGAR
          payload: PerguntaItem[]
      }
    | {
          type: PerguntaPesquisaSatisfacaoActionsTypes.ADICIONAR
      }
    | {
          type: PerguntaPesquisaSatisfacaoActionsTypes.REMOVER
          payload: { localId: number; dbId: number | null }
      }
    | {
          type: PerguntaPesquisaSatisfacaoActionsTypes.ATUALIZAR_CAMPO
          payload: { localId: number; campo: keyof PerguntaItem; valor: string | number | null }
      }
    | {
          type: PerguntaPesquisaSatisfacaoActionsTypes.CONFIRMAR_SAVE
          payload: Array<{ id: number }>
      }
